import request from '@/utils/request'

// 查询订单列表
export function queryStoreOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询订单地址
export function queryStoreOrderAddress(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrderAddress',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 发货
export function sendStoreOrderCart(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.sendStoreOrderCart',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 打印小票
export function orderPrinter(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/printer.orderPrinter',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 导出数据
export function exportData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}